import {
  type UpsertJobOfferInputDTO,
  UpsertJobOfferInputDTOZ
} from '@algoacademy/backend/modules/career/endpoints/mutations/upsert-job-offer/input.dto'
import type { GetAllCareersOutputDTO } from '@algoacademy/backend/modules/career/endpoints/queries/get-all-careers/output.dto'
import { zodResolver } from '@hookform/resolvers/zod'
import type { DefaultValues, UseFormProps } from 'react-hook-form'

type JobOfferDTO = GetAllCareersOutputDTO['careers'][0]

export function getUpsertJobOfferByIdFormDefaultValues(
  jobOffer?: JobOfferDTO
): UseFormProps<UpsertJobOfferInputDTO> {
  const defaultValues: DefaultValues<UpsertJobOfferInputDTO> = {
    id: jobOffer?.id ?? undefined,
    positionName: jobOffer?.positionName ?? '',
    isActive: jobOffer?.isActive ?? true,
    description: jobOffer?.description ?? '',
    recruitmentProcess: jobOffer?.recruitmentProcess ?? [],
    markdownAndAttachments: {
      markdown: {
        id: jobOffer?.markdownAndAttachments?.markdown?.id ?? 'Wprowadź treść oferty...',
        content: jobOffer?.markdownAndAttachments?.markdown?.content ?? ''
      },
      attachments:
        jobOffer?.markdownAndAttachments?.attachments?.map(attachment => ({
          id: attachment?.id ?? '',
          name: attachment?.name ?? '',
          url: attachment?.url ?? ''
        })) ?? []
    },
    salary: {
      uop: jobOffer?.salary?.uop ?? null,
      b2b: jobOffer?.salary?.b2b ?? null,
      uz: jobOffer?.salary?.uz ?? null
    }
  }

  return {
    resolver: zodResolver(UpsertJobOfferInputDTOZ),
    mode: 'onSubmit',
    defaultValues
  }
}
